module.exports = __webpack_public_path__ + "img/scan (8).ac2c76cc.png";